import { getQrCode } from "@/api/course-column";

export default async function(id, obj) {
  if (this.isGetting[id]) return;

  this.$set(this.isGetting, id, true);
  const { isError, data } = await getQrCode(id);
  this.$set(this.isGetting, id, false);
  if (isError) return;

  if (!data.qr_code) return;
  if (!obj) return window.open(data.qr_code);
  Object.assign(obj, { src: data.qr_code });
}
